import { ReactNode } from "react";
import { BackButton } from "../buttons/backButton";
import { PageTitle } from "./pageTitle";

export const PageHeader = ({
  pageTitle,
  hasBack,
  onBackClick = () => {},
  hasRightChildren = false,
  rightChildren,
  rightChildrenClassName,
  hasLeftChildren = false,
  leftChildren,
  className,
  pageTitleClassName,
}: {
  pageTitle: string;
  hasBack: boolean;
  onBackClick?: () => void;
  hasRightChildren?: boolean;
  rightChildren?: ReactNode;
  rightChildrenClassName?: string;
  hasLeftChildren?: boolean;
  leftChildren?: ReactNode;
  className?: string;
  pageTitleClassName?: string;
}) => {
  return (
    <div className={`flex flex-col flex-wrap gap-4 ${className}`}>
      {hasBack && (
        <BackButton
          text="Back"
          onClick={() => {
            onBackClick();
          }}
          className=""
        />
      )}

      <div className="flex items-center justify-between gap-3">
        <div className="flex flex-1 flex-row items-center gap-6">
          {pageTitle && (
            <PageTitle text={pageTitle} className={`${pageTitleClassName}`} />
          )}

          {hasLeftChildren && leftChildren}
        </div>

        {hasRightChildren && (
          <div className={`w-fit md:w-max ${rightChildrenClassName}`}>
            {rightChildren}
          </div>
        )}
      </div>
    </div>
  );
};
